module.exports = __webpack_public_path__ + "static/media/PromotionBlackIcon.62507553.svg";